module.exports = __webpack_public_path__ + "static/img/3.730f3fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/3.png
// module id = +S4c
// module chunks = 0